const state = {
  companyForm: {},
  projectForm: {},
  currentScrolH: 0, // 当前滚动高度
  currentSearch: {}, // 当前项目搜索状况
  currentPage: 1, // 当前页数
  //  当前是否修改过
  isCurrentModify: false,
  currentPageWork: 1, // 考勤的
  currentSalaryList: {} // 当前数据
}
const mutations = {
  SET_COMPANYLISTFORM: (state, companyForm) => {
    state.companyForm = companyForm
  },
  SET_PROJECTFORM: (state, projectForm) => {
    state.projectForm = projectForm
  },
  SET_CURRENTSCROLH: (state, currentScrolH) => {
    state.currentScrolH = currentScrolH
  },
  SET_CURRENTSEARCH: (state, currentSearch) => {
    state.currentSearch = currentSearch
  },
  SET_CURRENTPAGE: (state, currentPage) => {
    state.currentPage = currentPage
  },
  SET_CURRENTPAGEWORK: (state, currentPageWork) => {
    state.currentPageWork = currentPageWork
  },
  SET_ISCURRENTMODIFY: (state, isCurrentModify) => {
    state.isCurrentModify = isCurrentModify
  },
  SET_CURRENTSALARYLIST: (state, currentSalaryList) => {
    state.currentSalaryList = currentSalaryList
  }
}

export default {
  // namespaced: true, // 命名作用域
  state,
  mutations
}
